<template>
    <section class="text-white" id="about">
        <div id="about-header" class="masthead">
            <div class="container h-100 d-flex justify-content-center">
                <div class="my-auto">
                    <hr class="light" data-aos="fade-right">
                    <h1 class="text-white text-center">
                        NUESTRA HISTORIA <br>
                        <small>un legado de calidad</small>
                    </h1>
                    <hr class="light" data-aos="fade-left">
                </div>
            </div>
        </div>
        <div class="container-fluid no-repeat-background section-bg" id="back-somos">
            <div class="container">
                <div  class="row text-dark">
                    <div class="col-xl-7 offset-xl-5">
                        <h2 class="display-3">&nbsp;</h2>
                    </div>
                    <div data-aos="flip-left" class="col-xl-7 offset-xl-5 col-lg-6 offset-lg-6 col-md-12">
                        <h2 class="">¿Quiénes somos?</h2>
                        <p class="text-justify ">
                            <b>Grupo COSMIC</b> forma parte del Grupo Ohla, expertos en Gestión Omnicanal del Retail y Shopper Marketing. <br><br>
                            Junto a las 4 compañías del grupo, Touch, Vision y Marketing, Redvolution y nosotros, tenemos operación en toda la alianza del Pacífico y Centro América: México, Guatemala, El Salvador, Honduras, Nicaragua, Costa Rica, Puerto Rico, Panamá, República Dominicana, Colombia, Perú y Chile.<br><br>
                            Con más de 40 años de experiencia, especializados en soluciones de promoción y servicio, en Grupo Cosmic nos hemos posicionado como una agencia de resultados, a través de la mejora continua y actitud de servicio, cubriendo así en conjunto con Grupo Ohla el mercado nacional e internacional.
                        </p>
                    </div>
                    <div data-aos="flip-up" class="col-xl-7 offset-xl-5 col-lg-5 offset-lg-4 col-md-12">
                        <h2 class="">Misión</h2>
                        <p class="text-justify ">Ser la mejor solución en servicios de shopper marketing a través de innovación, tecnología e inteligencia de negocio, agregando valor a cada proceso para garantizar la satisfacción de nuestros clientes.</p>
                    </div>
                    <div data-aos="flip-right" class="col-xl-7 offset-xl-5 col-lg-5 offset-lg-4 col-md-12">
                        <h2 class="">Visión</h2>
                        <p class="text-justify ">Para 2025 seremos reconocidos como un referente en la industria del Shopper Marketing en América Latina, cumpliendo los estándares de calidad.</p>
                    </div>
                    <div class="col-xl-7 offset-xl-5">
                        <h2 class="display-1">&nbsp;</h2>
                    </div>

                    <div data-aos="flip-right" class="col-xl-8 offset-xl-4 col-lg-8 col-md-12">
                        <h2 class="">¿Cómo lo logramos?</h2>
                        <p class="text-justify ">Desarrollando colaboradores, en sinergia con proveedores y evolucionando con clientes a través de herramientas innovadoras de promoción en el punto de venta, canales de distribución, consumo y otros servicios.</p>
                    </div>
                    <div class="col-xl-7 offset-xl-5">
                        <h2 class="display-1">&nbsp;</h2>
                    </div>

                    <div class="col-xl-10 offset-xl-2">
                        <h2 class="">Valores</h2>
                    </div>
                    <div class="col-xl-12 d-none d-lg-block">
                        <img class="mx-auto d-block" style="width: 80%; height: auto; margin: 0 auto;" src="/../img/esquema_quienes_somos.png">
                    </div>

                    <div class="d-lg-none col-xl-12">

                        <div  data-aos="fade-left" class="col-sm-12">
                            <img style="width: 100px;" src="/../img/compromiso.png">
                            <h2 class="text-dark">Compromiso</h2>
                            <p class="text-left ">En la pasión por que las cosas sucedan de acuerdo a los estándares de excelencia.</p>
                        </div>
                        <div data-aos="fade-right" class="col-sm-12">
                            <img style="width: 100px;" src="/../img/trabajo.png">
                            <h2 class="text-dark">Trabajo en equipo</h2>
                            <p class="text-left ">Unimos fuerzas por cumplir objetivos siempre buscando la eficacia de los procesos y conectar a nuestros clientes, shoppers y colaboradores.</p>
                        </div>
                        <div data-aos="fade-left" class="col-sm-12">
                            <img style="width: 100px;" src="/../img/integridad.png">
                            <h2 class="text-dark">Integridad y respeto</h2>
                            <p class="text-left ">Aplicampos los valores, principios y normas en las operaciones diarias e la corporación.</p>
                        </div>
                        <div data-aos="fade-right" class="col-sm-12">
                            <img style="width: 100px;" src="/../img/mejora.png">
                            <h2 class="text-dark">Mejora continua</h2>
                            <p class="text-left ">Procesos generales que generan calidad en el servicio.</p>
                        </div>
                        <div data-aos="fade-left" class="col-sm-12">
                            <img style="width: 100px;" src="/../img/innovacion.png">
                            <h2 class="text-dark">Innovacion</h2>
                            <p class="text-left ">Desarrollamos alternativas innovadoras, ideas frescas y respuestas creativas.</p>
                        </div>

                        <div class="col-xl-12">
                            <h2 class="display-3">&nbsp;</h2>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>

export default {
    name: 'About',
    components: {
    },
    data () {
        return {

        }
    },
    mounted() {

    },
    beforeDestroy() {

    },
    methods: {
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.img-center {
    display: block;
    margin: auto;
}
.red {
    color: #b21621;
}
.hoverinfo {
  cursor: pointer !important;
}
.project-info {
  position: fixed;
  display: block;
  width: calc(100% - 300px);
  z-index: 999;
  height: 400px;
  bottom: -400px;
  border: none;
  transition: all 0.3s ease;
  background-color: #fff;
}
.map-container {
  position: absolute;
  left: 0;
  top: 0;
}
.map {
  display: inline-flex;
  flex-wrap: nowrap;
  flex-direction: row;
  justify-content: center;
  justify-items: center;
  align-content: center;
  align-items: center;
  overflow: hidden;
}
.project-info.show {
  bottom: 0;
}

.parent:nth-child(odd) {
    color: #000;
}
.parent:nth-child(even) {
    color: #b21621;
}

/* after the first non-.parent, toggle colors */
li:not(.parent) ~ .parent:nth-child(odd) {
    color: #b21621;
}
li:not(.parent) ~ .parent:nth-child(even) {
    color: #000;
}

/* after the second non-.parent, toggle again */
li:not(.parent) ~ li:not(.parent) ~ .parent:nth-child(odd) {
    color: #000;
}
li:not(.parent) ~ li:not(.parent) ~ .parent:nth-child(even) {
    color: #b21621;
}
</style>



// WEBPACK FOOTER //
// resources/assets/vue/components/about/About.vue